<mat-toolbar class="mat-elevation-z2" style="height: 48px">
  <nav mat-tab-nav-bar>
    <a
      mat-tab-link
      [routerLink]="['./pzHr']"
      routerLinkActive
      #rla1="routerLinkActive"
      [active]="rla1.isActive"
    >
      Overview
    </a>
    <a
      mat-tab-link
      [routerLink]="['./PpCEC']"
      routerLinkActive
      #rla2="routerLinkActive"
      [active]="rla2.isActive"
    >
      Orders
    </a>
    <a
      mat-tab-link
      [routerLink]="['./QoKr']"
      routerLinkActive
      #rla3="routerLinkActive"
      [active]="rla3.isActive"
    >
      Carts
    </a>
    <a
      mat-tab-link
      [routerLink]="['./kuUKB']"
      routerLinkActive
      #rla4="routerLinkActive"
      [active]="rla4.isActive"
    >
      Funnel
    </a>
    <a
      mat-tab-link
      [routerLink]="['./ONgGC']"
      routerLinkActive
      #rla5="routerLinkActive"
      [active]="rla5.isActive"
    >
      Travel Advisors
    </a>
    <a
      mat-tab-link
      [routerLink]="['./2PgGC']"
      routerLinkActive
      #rla6="routerLinkActive"
      [active]="rla6.isActive"
    >
      Assignment Proposals
    </a>
    <a
      mat-tab-link
      [routerLink]="['./bl6GC']"
      routerLinkActive
      #rla7="routerLinkActive"
      [active]="rla7.isActive"
    >
      Compensi Travel Advisors
    </a>
    <a
      mat-tab-link
      [routerLink]="['./NohQC']"
      routerLinkActive
      #rla8="routerLinkActive"
      [active]="rla8.isActive"
    >
      Corrispettivi NOW s.r.l.
    </a>
  </nav>
</mat-toolbar>

<router-outlet></router-outlet>
